import { SerializedError } from "@reduxjs/toolkit";
import { differenceInMilliseconds } from "date-fns";
import { FIVE_MINUTES_MS } from "helpers";
import { LoadingState } from "model/Types/loading";
import React from "react";
import { useSelector } from "react-redux";
import { useIsReadonlyCheck } from "redux/auth/selectors";
import { useAppDispatch } from "redux/store";
import { getAllCampaignsBudgetsWithSpend } from "./budgetsAsyncActions";
import { ICampaignsBudgetsMap } from "./budgetsSlice";
import { getCampaignsBudgetsState } from "./selectors";

const BUDGETS_LOAD_THROTTLE_MS = FIVE_MINUTES_MS;

type IResult = [ICampaignsBudgetsMap, boolean, SerializedError | null];
function useCampaignsBudgetsMap(): IResult {
  const dispatch = useAppDispatch();
  const isReadonlyUser = useIsReadonlyCheck();

  const { budgetsMap, loadingState, error, loadedTimestamp } = useSelector(
    getCampaignsBudgetsState
  );

  React.useEffect(() => {
    if (isReadonlyUser === true) {
      return;
    }
    if (
      loadingState === LoadingState.initial ||
      (loadedTimestamp &&
        differenceInMilliseconds(Date.now(), loadedTimestamp) >
          BUDGETS_LOAD_THROTTLE_MS)
    ) {
      dispatch(getAllCampaignsBudgetsWithSpend());
    }
  }, [loadingState, dispatch, isReadonlyUser, loadedTimestamp]);

  return [budgetsMap, loadingState === LoadingState.loading, error];
}

export default useCampaignsBudgetsMap;
